const role_details = {
    back_to_roles: 'กลับไปที่บทบาท',
    identifier: 'รหัสประจำตัว',
    delete_description: 'การดำเนินการนี้จะลบสิทธิ์ที่เกี่ยวข้องกับบทบาทนี้ออกจากผู้ใช้ที่ได้รับผลกระทบและลบการเชื่อมโยงระหว่างบทบาท ผู้ใช้ และสิทธิ์',
    role_deleted: '{{name}} ถูกลบเรียบร้อยแล้ว',
    general_tab: 'ทั่วไป',
    users_tab: 'ผู้ใช้',
    m2m_apps_tab: 'แอปพลิเคชันเครื่องต่อเครื่อง',
    permissions_tab: 'สิทธิ์',
    settings: 'การตั้งค่า',
    settings_description: 'บทบาทคือกลุ่มของสิทธิ์ที่สามารถมอบหมายให้กับผู้ใช้ได้ นอกจากนี้ยังเป็นวิธีรวมสิทธิ์ที่กำหนดไว้สำหรับ API ต่าง ๆ เพื่อให้การเพิ่ม ลบ หรือแก้ไขสิทธิ์มีประสิทธิภาพมากขึ้นเมื่อเปรียบเทียบกับการตั้งค่าสิทธิ์แยกกับผู้ใช้แต่ละคน',
    field_name: 'ชื่อ',
    field_description: 'คำอธิบาย',
    field_is_default: 'บทบาทเริ่มต้น',
    field_is_default_description: 'ตั้งค่าบทบาทนี้เป็นบทบาทเริ่มต้นสำหรับผู้ใช้ใหม่ สามารถตั้งบทบาทเริ่มต้นได้หลายบทบาท ซึ่งจะมีผลกับผู้ใช้ที่สร้างผ่าน Management API ด้วย',
    type_m2m_role_tag: 'เครื่องต่อเครื่อง',
    type_user_role_tag: 'ผู้ใช้',
    m2m_role_notification: 'กำหนดบทบาทเครื่องต่อเครื่องนี้ให้กับแอปพลิเคชันเครื่องต่อเครื่องเพื่อให้เข้าถึงทรัพยากร API ที่เกี่ยวข้อง <a>สร้างแอปพลิเคชันเครื่องต่อเครื่อง</a>ก่อน หากคุณยังไม่ได้สร้าง',
    permission: {
        assign_button: 'กำหนดสิทธิ์',
        assign_title: 'กำหนดสิทธิ์',
        assign_subtitle: 'กำหนดสิทธิ์ให้กับบทบาทนี้ บทบาทนี้จะได้รับสิทธิ์ที่เพิ่ม และผู้ใช้ที่มีบทบาทนี้จะได้รับสิทธิ์เหล่านี้',
        assign_form_field: 'กำหนดสิทธิ์',
        added_text: 'เพิ่มสิทธิ์ {{count, number}} รายการแล้ว',
        added_text_other: 'เพิ่มสิทธิ์ {{count, number}} รายการแล้ว',
        api_permission_count: 'สิทธิ์ {{count, number}} รายการ',
        api_permission_count_other: 'สิทธิ์ {{count, number}} รายการ',
        confirm_assign: 'กำหนดสิทธิ์',
        permission_assigned: 'กำหนดสิทธิ์ที่เลือกไปยังบทบาทนี้เรียบร้อยแล้ว',
        deletion_description: 'ถ้าหากสิทธิ์นี้ถูกลบ ผู้ใช้ที่มีบทบาทนี้จะสูญเสียการเข้าถึงที่ได้รับ',
        permission_deleted: 'ลบสิทธิ์ "{{name}}" ออกจากบทบาทนี้เรียบร้อยแล้ว',
        empty: 'ไม่มีสิทธิ์ให้เลือก',
    },
    users: {
        assign_button: 'กำหนดผู้ใช้',
        name_column: 'ผู้ใช้',
        app_column: 'แอปพลิเคชัน',
        latest_sign_in_column: 'เข้าสู่ระบบล่าสุด',
        delete_description: 'จะยังอยู่ในกลุ่มผู้ใช้ของคุณแต่จะสูญเสียสิทธิ์ในบทบาทนี้',
        deleted: '{{name}} ถูกลบออกจากบทบาทนี้เรียบร้อยแล้ว',
        assign_title: 'กำหนดผู้ใช้ให้กับ {{name}}',
        assign_subtitle: 'ค้นหาผู้ใช้ที่เหมาะสมโดยค้นหาจากชื่อ อีเมล เบอร์โทรศัพท์ หรือรหัสผู้ใช้',
        assign_field: 'กำหนดผู้ใช้',
        confirm_assign: 'กำหนดผู้ใช้',
        assigned_toast_text: 'กำหนดผู้ใช้ที่เลือกให้กับบทบาทนี้เรียบร้อยแล้ว',
        empty: 'ไม่มีผู้ใช้',
    },
    applications: {
        assign_button: 'กำหนดแอปพลิเคชันเครื่องต่อเครื่อง',
        name_column: 'แอปพลิเคชัน',
        app_column: 'แอปพลิเคชันเครื่องต่อเครื่อง',
        description_column: 'คำอธิบาย',
        delete_description: 'จะยังอยู่ในกลุ่มแอปพลิเคชันของคุณแต่จะสูญเสียสิทธิ์ในบทบาทนี้',
        deleted: '{{name}} ถูกลบออกจากบทบาทนี้เรียบร้อยแล้ว',
        assign_title: 'กำหนดแอปพลิเคชันเครื่องต่อเครื่องให้กับ {{name}}',
        assign_subtitle: 'ค้นหาแอปพลิเคชันเครื่องต่อเครื่องที่เหมาะสมโดยค้นหาจากชื่อ คำอธิบาย หรือรหัสแอป',
        assign_field: 'กำหนดแอปพลิเคชันเครื่องต่อเครื่อง',
        confirm_assign: 'กำหนดแอปพลิเคชันเครื่องต่อเครื่อง',
        assigned_toast_text: 'กำหนดแอปพลิเคชันที่เลือกให้กับบทบาทนี้เรียบร้อยแล้ว',
        empty: 'ไม่มีแอปพลิเคชัน',
    },
};
export default Object.freeze(role_details);
